import { store } from "../store";
import apiClientToken from "../plugins/axiosToken";
import Controller from "./Controller";

export default class CatalogoConversion{

    cargaArchivo(context,param){        
        var t = context     
        var controller = new Controller();
        return new Promise(function(resolve,reject){            
            apiClientToken.post(store.getters.getUrlServicios + "WCFImportaciones.svc/RestService/cargaArchivo",param)        
            .then(function(response){
                //console.log(response.data.data);
                resolve(controller.getData(context,response));
            })
            .catch(function(error){
              t.$toast.add({
                  severity:"error",
                  summary:"ERROR",
                  detail:"Error al obtener datos del servidor",
                  life: 3000
              });
              console.log(error);
              reject(error);
            })
        })
    }

    GetImportaciones(context,param){        
        var t = context     
        var controller = new Controller();
        return new Promise(function(resolve,reject){            
            apiClientToken.get(store.getters.getUrlServicios + "WCFImportaciones.svc/RestService/GetImportaciones/" + param)        
            .then(function(response){
                //console.log(response.data.data);
                resolve(controller.getData(context,response));
            })
            .catch(function(error){
              t.$toast.add({
                  severity:"error",
                  summary:"ERROR",
                  detail:"Error al obtener datos del servidor",
                  life: 3000
              });
              console.log(error);
              reject(error);
            })
        })
    }

}